import React from "react";
import { InvoicingWorkflowStatCard } from "../Invoicing/components/InvoicingWorkflowLayout";
import "../Invoicing/components/invoicing-workflow.css";

const DashboardModuleCard = ({
  icon,
  name,
  description,
  value = "→",
  iconVariant = "blue",
  badge = 0,
  onClick,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      role='button'
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      title={description}
      className='group relative cursor-pointer rounded-[14px] transition duration-150 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/50'
    >
      {badge > 0 ? (
        <span
          className='absolute -right-2 -top-2 z-10 inline-flex min-w-[26px] items-center justify-center rounded-full bg-red-600 px-2 py-0.5 text-xs font-bold text-white shadow-md'
          aria-label={`${badge} pending`}
        >
          {badge}
        </span>
      ) : null}

      <InvoicingWorkflowStatCard
        icon={icon}
        value={value}
        label={name}
        subValue={description}
        iconVariant={iconVariant}
        highlight
      />
    </div>
  );
};

export default DashboardModuleCard;
